import cn from 'classnames';
import { type ForwardedRef, forwardRef, type HTMLProps, memo } from 'react';

import type { TABLE_BACKGROUND_COLORS } from '@didaskill/domain/html/constants';

export type RowProps = Omit<HTMLProps<HTMLTableRowElement>, 'ref'> & {
  /** Background color enum. */
  backgroundColor?: TABLE_BACKGROUND_COLORS;
};

export const RowBase = forwardRef(
  (
    { backgroundColor = null, className = null, ...props }: RowProps,
    ref: ForwardedRef<HTMLTableRowElement>,
  ) => <tr {...props} ref={ref} className={cn(className, backgroundColor)} />,
);

RowBase.displayName = 'Row';

export const Row = memo(RowBase);
